import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelText as _vModelText, vModelRadio as _vModelRadio, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" };
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30" };
const _hoisted_3 = {
    key: 0,
    class: "text-center py-5"
};
const _hoisted_4 = { key: 1 };
const _hoisted_5 = { class: "d-flex justify-content-between align-items-center mb-20" };
const _hoisted_6 = { class: "d-flex align-items-center" };
const _hoisted_7 = { class: "form-check form-switch mb-0" };
const _hoisted_8 = ["disabled"];
const _hoisted_9 = {
    key: 0,
    class: "fas fa-spinner fa-spin me-2"
};
const _hoisted_10 = { class: "row mt-4" };
const _hoisted_11 = { class: "col-md-12 mb-4" };
const _hoisted_12 = { class: "card border p-3 border-light-subtle rounded-1" };
const _hoisted_13 = { class: "row" };
const _hoisted_14 = { class: "col-md-6 mb-3" };
const _hoisted_15 = { class: "p-3 bg-light rounded-1" };
const _hoisted_16 = { class: "col-md-6 mb-3" };
const _hoisted_17 = { class: "p-3 bg-light rounded-1" };
const _hoisted_18 = { class: "col-md-6 mb-3" };
const _hoisted_19 = { class: "p-3 bg-light rounded-1" };
const _hoisted_20 = { class: "col-md-6 mb-3" };
const _hoisted_21 = { class: "p-3 bg-light rounded-1" };
const _hoisted_22 = { class: "col-md-6 mb-4" };
const _hoisted_23 = { class: "card h-100 border p-3 border-light-subtle rounded-1 card-hover" };
const _hoisted_24 = { class: "form-check mb-3" };
const _hoisted_25 = { class: "form-check mb-3" };
const _hoisted_26 = { class: "form-check mb-3" };
const _hoisted_27 = { class: "form-check mb-3" };
const _hoisted_28 = { class: "col-md-6 mb-4" };
const _hoisted_29 = { class: "card h-100 border p-3 border-light-subtle rounded-1" };
const _hoisted_30 = { class: "form-group mb-4" };
const _hoisted_31 = { class: "d-flex align-items-center" };
const _hoisted_32 = { class: "ms-3 badge bg-dark fs-6" };
const _hoisted_33 = { class: "col-md-12 mt-4" };
const _hoisted_34 = { class: "card border p-3 border-light-subtle rounded-1" };
const _hoisted_35 = { class: "table-responsive" };
const _hoisted_36 = { class: "table table-hover align-middle border-top mt-3" };
const _hoisted_37 = { class: "ps-3 fw-medium" };
const _hoisted_38 = { class: "text-muted" };
const _hoisted_39 = ["onUpdate:modelValue"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_LoaderComponent = _resolveComponent("LoaderComponent");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            (_ctx.isLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_LoaderComponent)
                ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                            _cache[15] || (_cache[15] = _createElementVNode("h5", { class: "card-title fw-bold mb-0 me-4" }, "Recommandations", -1)),
                            _createElementVNode("div", _hoisted_7, [
                                _withDirectives(_createElementVNode("input", {
                                    class: "form-check-input",
                                    type: "checkbox",
                                    id: "upsellActive",
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.settings.isActive) = $event))
                                }, null, 512), [
                                    [_vModelCheckbox, _ctx.settings.isActive]
                                ]),
                                _createElementVNode("label", {
                                    class: _normalizeClass(["form-check-label ms-2 fw-semibold", _ctx.settings.isActive ? 'text-success' : 'text-danger']),
                                    for: "upsellActive"
                                }, _toDisplayString(_ctx.settings.isActive ? 'Activé' : 'Désactivé'), 3)
                            ])
                        ]),
                        _createElementVNode("button", {
                            onClick: _cache[1] || (_cache[1] =
                                //@ts-ignore
                                (...args) => (_ctx.saveSettings && _ctx.saveSettings(...args))),
                            class: "btn btn-success rounded-1 px-4 py-2",
                            disabled: _ctx.isSaving
                        }, [
                            (_ctx.isSaving)
                                ? (_openBlock(), _createElementBlock("i", _hoisted_9))
                                : _createCommentVNode("", true),
                            _cache[16] || (_cache[16] = _createTextVNode(" Enregistrer les modifications ", -1))
                        ], 8, _hoisted_8)
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                                _cache[21] || (_cache[21] = _createElementVNode("h6", { class: "fw-bold text-black border-bottom pb-2 mb-3" }, "Configuration des textes", -1)),
                                _cache[22] || (_cache[22] = _createElementVNode("p", { class: "text-muted small mb-4" }, "Ces textes s'affichent dans le panier pour encourager les clients.", -1)),
                                _createElementVNode("div", _hoisted_13, [
                                    _createElementVNode("div", _hoisted_14, [
                                        _createElementVNode("div", _hoisted_15, [
                                            _cache[17] || (_cache[17] = _createElementVNode("label", { class: "fw-bold mb-2" }, "🇫🇷 Français", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.settings.title.fr) = $event)),
                                                class: "form-control mb-2",
                                                placeholder: "Ex: Envie d'une petite douceur ?"
                                            }, null, 512), [
                                                [_vModelText, _ctx.settings.title.fr]
                                            ]),
                                            _withDirectives(_createElementVNode("textarea", {
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.settings.hint.fr) = $event)),
                                                class: "form-control",
                                                rows: "2",
                                                placeholder: "Astuce: Ajoutez ces articles..."
                                            }, null, 512), [
                                                [_vModelText, _ctx.settings.hint.fr]
                                            ])
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_16, [
                                        _createElementVNode("div", _hoisted_17, [
                                            _cache[18] || (_cache[18] = _createElementVNode("label", { class: "fw-bold mb-2" }, "🇬🇧 Anglais", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.settings.title.en) = $event)),
                                                class: "form-control mb-2",
                                                placeholder: "Ex: Fancy a sweet treat?"
                                            }, null, 512), [
                                                [_vModelText, _ctx.settings.title.en]
                                            ]),
                                            _withDirectives(_createElementVNode("textarea", {
                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.settings.hint.en) = $event)),
                                                class: "form-control",
                                                rows: "2",
                                                placeholder: "Tip: Add these items..."
                                            }, null, 512), [
                                                [_vModelText, _ctx.settings.hint.en]
                                            ])
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_18, [
                                        _createElementVNode("div", _hoisted_19, [
                                            _cache[19] || (_cache[19] = _createElementVNode("label", { class: "fw-bold mb-2" }, "🇮🇹 Italien", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.settings.title.it) = $event)),
                                                class: "form-control mb-2",
                                                placeholder: "Ex: Voglia di un dolce?"
                                            }, null, 512), [
                                                [_vModelText, _ctx.settings.title.it]
                                            ]),
                                            _withDirectives(_createElementVNode("textarea", {
                                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.settings.hint.it) = $event)),
                                                class: "form-control",
                                                rows: "2",
                                                placeholder: "Suggerimento: aggiungi questi..."
                                            }, null, 512), [
                                                [_vModelText, _ctx.settings.hint.it]
                                            ])
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_20, [
                                        _createElementVNode("div", _hoisted_21, [
                                            _cache[20] || (_cache[20] = _createElementVNode("label", { class: "fw-bold mb-2" }, "🇩🇪 Allemand", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.settings.title.de) = $event)),
                                                class: "form-control mb-2",
                                                placeholder: "Ex: Lust auf eine kleine Süßigkeit?"
                                            }, null, 512), [
                                                [_vModelText, _ctx.settings.title.de]
                                            ]),
                                            _withDirectives(_createElementVNode("textarea", {
                                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.settings.hint.de) = $event)),
                                                class: "form-control",
                                                rows: "2",
                                                placeholder: "Tipp: Fügen Sie diese Artikel..."
                                            }, null, 512), [
                                                [_vModelText, _ctx.settings.hint.de]
                                            ])
                                        ])
                                    ])
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("div", _hoisted_23, [
                                _cache[27] || (_cache[27] = _createElementVNode("h6", { class: "fw-bold text-black border-bottom pb-2 mb-3" }, "Choix de l'Algorithme", -1)),
                                _createElementVNode("div", _hoisted_24, [
                                    _withDirectives(_createElementVNode("input", {
                                        class: "form-check-input",
                                        type: "radio",
                                        name: "algo",
                                        id: "algo1",
                                        value: 1,
                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.settings.algorithmId) = $event))
                                    }, null, 512), [
                                        [_vModelRadio, _ctx.settings.algorithmId]
                                    ]),
                                    _cache[23] || (_cache[23] = _createElementVNode("label", {
                                        class: "form-check-label ms-2",
                                        for: "algo1"
                                    }, [
                                        _createElementVNode("span", { class: "fw-semibold d-block" }, "Algorithme 1 : Fréquemment achetés ensemble"),
                                        _createElementVNode("small", { class: "text-muted" }, "Propose des articles souvent commandés avec ceux présents dans le panier.")
                                    ], -1))
                                ]),
                                _createElementVNode("div", _hoisted_25, [
                                    _withDirectives(_createElementVNode("input", {
                                        class: "form-check-input",
                                        type: "radio",
                                        name: "algo",
                                        id: "algo2",
                                        value: 2,
                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.settings.algorithmId) = $event))
                                    }, null, 512), [
                                        [_vModelRadio, _ctx.settings.algorithmId]
                                    ]),
                                    _cache[24] || (_cache[24] = _createElementVNode("label", {
                                        class: "form-check-label ms-2",
                                        for: "algo2"
                                    }, [
                                        _createElementVNode("span", { class: "fw-semibold d-block" }, "Algorithme 2 : Habitudes client"),
                                        _createElementVNode("small", { class: "text-muted" }, "Recommandations personnalisées basées sur les 5 dernières commandes du client.")
                                    ], -1))
                                ]),
                                _createElementVNode("div", _hoisted_26, [
                                    _withDirectives(_createElementVNode("input", {
                                        class: "form-check-input",
                                        type: "radio",
                                        name: "algo",
                                        id: "algo3",
                                        value: 3,
                                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_ctx.settings.algorithmId) = $event))
                                    }, null, 512), [
                                        [_vModelRadio, _ctx.settings.algorithmId]
                                    ]),
                                    _cache[25] || (_cache[25] = _createElementVNode("label", {
                                        class: "form-check-label ms-2",
                                        for: "algo3"
                                    }, [
                                        _createElementVNode("span", { class: "fw-semibold d-block" }, "Algorithme 3 : Règles simples (Configurables)"),
                                        _createElementVNode("small", { class: "text-muted" }, "Si Pizza -> Boisson, si Pâtes -> Dessert. Inclut la suggestion de frais de livraison offerts.")
                                    ], -1))
                                ]),
                                _createElementVNode("div", _hoisted_27, [
                                    _withDirectives(_createElementVNode("input", {
                                        class: "form-check-input",
                                        type: "radio",
                                        name: "algo",
                                        id: "algo4",
                                        value: 4,
                                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((_ctx.settings.algorithmId) = $event))
                                    }, null, 512), [
                                        [_vModelRadio, _ctx.settings.algorithmId]
                                    ]),
                                    _cache[26] || (_cache[26] = _createElementVNode("label", {
                                        class: "form-check-label ms-2",
                                        for: "algo4"
                                    }, [
                                        _createElementVNode("span", { class: "fw-semibold d-block text-primary" }, "Algorithme 4 : Hybride (Conseillé)"),
                                        _createElementVNode("small", { class: "text-muted d-block" }, "Mélange intelligent des approches précédentes pour maximiser la pertinence."),
                                        _createElementVNode("span", { class: "badge bg-primary-subtle text-primary mt-1" }, "Recommandé")
                                    ], -1))
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("div", _hoisted_29, [
                                _cache[30] || (_cache[30] = _createElementVNode("h6", { class: "fw-bold text-black border-bottom pb-2 mb-3" }, "Paramètres d'affichage", -1)),
                                _createElementVNode("div", _hoisted_30, [
                                    _cache[28] || (_cache[28] = _createElementVNode("label", { class: "d-block fw-semibold mb-10" }, "Nombre de produits proposés", -1)),
                                    _createElementVNode("div", _hoisted_31, [
                                        _withDirectives(_createElementVNode("input", {
                                            type: "range",
                                            class: "form-range flex-grow-1",
                                            min: "3",
                                            max: "9",
                                            step: "1",
                                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((_ctx.settings.limit) = $event))
                                        }, null, 512), [
                                            [
                                                _vModelText,
                                                _ctx.settings.limit,
                                                void 0,
                                                { number: true }
                                            ]
                                        ]),
                                        _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.settings.limit) + " produits", 1)
                                    ]),
                                    _cache[29] || (_cache[29] = _createElementVNode("small", { class: "text-muted" }, "Choisissez entre 3 et 9 articles à afficher dans le panier.", -1))
                                ]),
                                _cache[31] || (_cache[31] = _createElementVNode("div", { class: "alert alert-info border-0 rounded-1 small mb-0" }, [
                                    _createElementVNode("i", { class: "fas fa-info-circle me-2" }),
                                    _createTextVNode(" Si l'algorithme sélectionné ne trouve pas assez de produits, le système complétera automatiquement avec vos articles les plus populaires. ")
                                ], -1))
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("div", _hoisted_34, [
                                _cache[35] || (_cache[35] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center border-bottom pb-2 mb-3" }, [
                                    _createElementVNode("h6", { class: "fw-bold text-black mb-0" }, "Mapping des catégories (Pour Algorithme 3)"),
                                    _createElementVNode("span", { class: "badge bg-warning-subtle text-warning" }, "Action requise")
                                ], -1)),
                                _cache[36] || (_cache[36] = _createElementVNode("p", { class: "text-muted small" }, "Associez vos catégories à des types standards pour que les règles automatiques (ex: Suggérer une boisson avec une Pizza) fonctionnent correctement.", -1)),
                                _createElementVNode("div", _hoisted_35, [
                                    _createElementVNode("table", _hoisted_36, [
                                        _cache[34] || (_cache[34] = _createElementVNode("thead", { class: "bg-light" }, [
                                            _createElementVNode("tr", null, [
                                                _createElementVNode("th", { class: "ps-3" }, "Catégorie"),
                                                _createElementVNode("th", null, "Restaurant"),
                                                _createElementVNode("th", null, "Type de produit"),
                                                _createElementVNode("th", { class: "text-end pe-3" }, "Action")
                                            ])
                                        ], -1)),
                                        _createElementVNode("tbody", null, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category) => {
                                                return (_openBlock(), _createElementBlock("tr", {
                                                    key: category.id
                                                }, [
                                                    _createElementVNode("td", _hoisted_37, _toDisplayString(category.name), 1),
                                                    _createElementVNode("td", _hoisted_38, _toDisplayString(category.restaurantName || '-'), 1),
                                                    _createElementVNode("td", null, [
                                                        _withDirectives(_createElementVNode("select", {
                                                            class: "form-select form-select-sm shadow-none border-light-subtle rounded-0",
                                                            "onUpdate:modelValue": ($event) => ((_ctx.settings.categoryMapping[category.id]) = $event)
                                                        }, [...(_cache[32] || (_cache[32] = [
                                                                _createStaticVNode("<option value=\"none\" disabled selected data-v-6a47f2de>Sélectionner un type...</option><option value=\"pizza\" data-v-6a47f2de>🍕 Pizza / Plat Principal</option><option value=\"pasta\" data-v-6a47f2de>🍝 Pâtes</option><option value=\"salad\" data-v-6a47f2de>🥗 Entrée / Salade</option><option value=\"drink\" data-v-6a47f2de>🥤 Boisson / Soft</option><option value=\"dessert\" data-v-6a47f2de>🍰 Dessert / Sucré</option><option value=\"extra\" data-v-6a47f2de>🍟 Extra / Accompagnement</option>", 7)
                                                            ]))], 8, _hoisted_39), [
                                                            [_vModelSelect, _ctx.settings.categoryMapping[category.id]]
                                                        ])
                                                    ]),
                                                    _cache[33] || (_cache[33] = _createElementVNode("td", { class: "text-end pe-3 text-muted small" }, "Auto-sauvegardé", -1))
                                                ]));
                                            }), 128))
                                        ])
                                    ])
                                ])
                            ])
                        ])
                    ])
                ]))
        ])
    ]));
}
